export type MicrofrontendName =
    | 'cv'
    | 'minesweeper'
    | 'piechart'
    | 'selfdocument';

export interface IMicrofrontendRemote {
    /** Entry file emitted by the microfrontend's own build. */
    entry: string;
    /** Origin of the microfrontend's dev server. */
    origin: string;
    /** Entry module as served by that dev server. */
    source: string;
}

/**
 * This is the only place that knows where a microfrontend entry file lives. In
 * production the entry file is emitted by the build of that microfrontend into
 * build/apps/<name>/. In development the shell imports the entry module of the
 * dev server of that microfrontend instead.
 */
export const MICROFRONTEND_REMOTES: Record<
    MicrofrontendName,
    IMicrofrontendRemote
> = {
    cv: {
        entry: 'cv.js',
        origin: 'http://localhost:5174',
        source: 'src/main.ts',
    },
    minesweeper: {
        entry: 'main.js',
        origin: 'http://localhost:4200',
        source: 'main.js',
    },
    piechart: {
        entry: 'piechart.js',
        origin: 'http://localhost:5176',
        source: 'src/main.tsx',
    },
    selfdocument: {
        entry: 'selfdocument.js',
        origin: 'http://localhost:5175',
        source: 'src/main.tsx',
    },
};
